import config from '../services/config'

export const CDN_URLS = {
  dev: 'http://dev-cdn.swaypay.io.s3-us-west-2.amazonaws.com/',
  prod: 'https://cdn.swaypay.io/'
}

export function getHotelImageBaseUrl() {
  if (config.apiUrl.startsWith('https://api')) {
    return CDN_URLS.prod + 'hotelPrimaryPhotos/'
  } else {
    return CDN_URLS.dev + 'hotelPrimaryPhotos/'
  }
}
